<template>
	<div class="pagecontent">
		 <div class="modelstopimg">
			 <img :src="modelstopimg.bgImg"/>
		 </div>
		 <div class="modelscontent">
			 <div class="modelsspecial">
				 <div class="modelsmargin-first modelsconser">
					 <a  target="_blank"  :href="modelimg[1].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[1].imgurl" /></div>
						 <div class="modelsconser-text">
						 	<p class="modelsconser-tcon">
						 		{{modelimg[1].title}}
						 	</p>
						 </div>
					 </a>
				 	
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[2].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[2].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
								{{modelimg[2].title}}
							</p>
						 </div>
				 	</a>
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[3].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[3].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[3].title}}
							</p>
						 </div>
				 	</a>
				 </div> 
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[4].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[4].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[4].title}}
							</p>
						 </div>
				 	</a>
				 </div>
			 </div><div class="modelsspecial">
				 <div class="modelsmargin-first modelsconser">
					 <a  target="_blank"  :href="modelimg[5].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[5].imgurl" /></div>
						 <div class="modelsconser-text">
						 	<p class="modelsconser-tcon">
						 		{{modelimg[5].title}}
						 	</p>
						 </div>
					 </a>
				 	
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[6].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[6].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
								{{modelimg[6].title}}
							</p>
						 </div>
				 	</a>
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[7].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[7].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[7].title}}
							</p>
						 </div>
				 	</a>
				 </div> 
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[8].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[8].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[8].title}}
							</p>
						 </div>
				 	</a>
				 </div>
			 </div><div class="modelsspecial">
				 <div class="modelsmargin-first modelsconser">
					 <a  target="_blank"  :href="modelimg[9].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[9].imgurl" /></div>
						 <div class="modelsconser-text">
						 	<p class="modelsconser-tcon">
						 		{{modelimg[9].title}}
						 	</p>
						 </div>
					 </a>
				 	
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[10].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[10].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
								{{modelimg[10].title}}
							</p>
						 </div>
				 	</a>
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[11].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[11].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[11].title}}
							</p>
						 </div>
				 	</a>
				 </div> 
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[12].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[12].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[12].title}}
							</p>
						 </div>
				 	</a>
				 </div>
			 </div><div class="modelsspecial">
				 <div class="modelsmargin-first modelsconser">
					 <a  target="_blank"  :href="modelimg[13].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[13].imgurl" /></div>
						 <div class="modelsconser-text">
						 	<p class="modelsconser-tcon">
						 		{{modelimg[13].title}}
						 	</p>
						 </div>
					 </a>
				 	
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[14].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[14].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
								{{modelimg[14].title}}
							</p>
						 </div>
				 	</a>
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[15].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[15].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[15].title}}
							</p>
						 </div>
				 	</a>
				 </div> 
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[16].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[16].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[16].title}}
							</p>
						 </div>
				 	</a>
				 </div>
			 </div><div class="modelsspecial">
				 <div class="modelsmargin-first modelsconser">
					 <a  target="_blank"  :href="modelimg[17].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[17].imgurl" /></div>
						 <div class="modelsconser-text">
						 	<p class="modelsconser-tcon">
						 		{{modelimg[17].title}}
						 	</p>
						 </div>
					 </a>
				 	
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[18].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[18].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
								{{modelimg[18].title}}
							</p>
						 </div>
				 	</a>
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[19].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[19].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[19].title}}
							</p>
						 </div>
				 	</a>
				 </div> 
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[20].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[20].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
									{{modelimg[20].title}}
							</p>
						 </div>
				 	</a>
				 </div>
			 </div><div class="modelsspecial">
				 <div class="modelsmargin-first modelsconser">
					 <a  target="_blank"  :href="modelimg[21].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[21].imgurl" /></div>
						 <div class="modelsconser-text">
						 	<p class="modelsconser-tcon">
						 		{{modelimg[21].title}}
						 	</p>
						 </div>
					 </a>
				 	
				 </div>
				 <div class="modelsconser modelsmargin-all">
				 	<a  target="_blank"  :href="modelimg[22].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[22].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
								{{modelimg[22].title}}
							</p>
						 </div>
				 	</a>
				 </div>
				<div class="modelsconser modelsmargin-all">
					<a  target="_blank"  :href="modelimg[23].dourl" >
						 <div class="modelsconser-img "><img :src="modelimg[23].imgurl" /></div>
						 <div class="modelsconser-text">
							<p class="modelsconser-tcon">
								{{modelimg[23].title}}
							</p>
						 </div>
					</a>
				</div>
			 </div>
			 
		 </div>
		 
		 <div class="el-footer">
		   <Footer />
		 </div>
	</div>
	
</template>

<script>
	import modelstopimg from '../components/TopImg.vue'
	import Footer from '../components/Footer.vue'
	export default{
		name: '',
		components: { modelstopimg, Footer },
		props: {},
		data() {
			 return {
				 modelstopimg: {
				   title: '',
				   bgImg: require('../assets/images/webpagetop.png'),
				   content: '',
				   bl: false,
				  indexId: 11,
				 },
				 images:{
					 con1:require('../assets/images/webpage/serch.jpg'),
					 con2:require('../assets/images/webpage/mokuai.jpg'),
					 con3:require('../assets/images/webpage/moremodel.jpg'),
					 con4:require('../assets/images/webpage/serve.jpg')
				 },
				 modelimg:{
					 1:{
						title:'制造公司官网',
						imgurl:require('../assets/images/webpage/modelimgs/10.jpg'),
						dourl:'http://model.show.cydzy.com/10/cn',
					 },
					 2:{
						 title:'大气中英文企业网站',
						 imgurl:require('../assets/images/webpage/modelimgs/11.jpg'),
						 dourl:'http://model.show.cydzy.com/11',
					 },
					 3:{
						 title:'财税服务公司官网',
						 imgurl:require('../assets/images/webpage/modelimgs/12.jpg'),
						 dourl:'http://model.show.cydzy.com/12',
					 },
					 4:{
						 title:'大气产品设计展示官网',
						 imgurl:require('../assets/images/webpage/modelimgs/13.jpg'),
						 dourl:'http://model.show.cydzy.com/13',
					 },
					 5:{
						 title:'蓝色主题企业门户',
						 imgurl:require('../assets/images/webpage/modelimgs/14.jpg'),
						 dourl:'http://model.show.cydzy.com/14',
					 },
					 6:{
						 title:'红色主题企业门户',
						 imgurl:require('../assets/images/webpage/modelimgs/15.jpg'),
						 dourl:'http://model.show.cydzy.com/15',
					 },
					 7:{
						 title:'软件开发服务企业网站',
						 imgurl:require('../assets/images/webpage/modelimgs/16.jpg'),
						 dourl:'http://model.show.cydzy.com/16',
					 },
					 8:{
						 title:'浅绿色公司官网产品展示官网',
						 imgurl:require('../assets/images/webpage/modelimgs/17.jpg'),
						 dourl:'http://model.show.cydzy.com/17',
					 },
					 9:{
						 title:'大气多图公司企业网站',
						 imgurl:require('../assets/images/webpage/modelimgs/18.jpg'),
						 dourl:'http://model.show.cydzy.com/18',
					 },
					 10:{
						 title:'产品展示为主官网',
						 imgurl:require('../assets/images/webpage/modelimgs/19.jpg'),
						 dourl:'http://model.show.cydzy.com/19',
					 },
					 11:{
						 title:'大气企业门户官网',
						 imgurl:require('../assets/images/webpage/modelimgs/20.jpg'),
						 dourl:'http://model.show.cydzy.com/20',
					 },
					 12:{
						 title:'软件开发企业官网',
						 imgurl:require('../assets/images/webpage/modelimgs/21.jpg'),
						 dourl:'http://model.show.cydzy.com/21',
					 },
					 13:{
						 title:'纺织纱织企业官网',
						 imgurl:require('../assets/images/webpage/modelimgs/22.jpg'),
						 dourl:'http://model.show.cydzy.com/22',
					 }, 
					 14:{
						 title:'全屏整页滚动官网',
						 imgurl:require('../assets/images/webpage/modelimgs/1.png'),
						 dourl:'http://model.show.cydzy.com/1',
					 }, 15:{
						 title:'长页滚动官网',
						 imgurl:require('../assets/images/webpage/modelimgs/2.jpg'),
						 dourl:'http://model.show.cydzy.com/2',
					 }, 16:{
						 title:'简洁大气官网模板',
						 imgurl:require('../assets/images/webpage/modelimgs/3.jpg'),
						 dourl:'http://model.show.cydzy.com/3',
					 }, 17:{
						 title:'大气汽车红色官网模板',
						 imgurl:require('../assets/images/webpage/modelimgs/4.jpg'),
						 dourl:'http://model.show.cydzy.com/4',
					 }, 18:{
						 title:'制造公司企业模板',
						 imgurl:require('../assets/images/webpage/modelimgs/5.jpg'),
						 dourl:'http://model.show.cydzy.com/5',
					 }, 19:{
						 title:'简洁白色全屏模板',
						 imgurl:require('../assets/images/webpage/modelimgs/6.jpg'),
						 dourl:'http://model.show.cydzy.com/6',
					 }, 20:{
						 title:'软件开发简洁官网模板',
						 imgurl:require('../assets/images/webpage/modelimgs/7.jpg'),
						 dourl:'http://model.show.cydzy.com/7',
					 }, 21:{
						 title:'服务公司简洁官网模板',
						 imgurl:require('../assets/images/webpage/modelimgs/8.jpg'),
						 dourl:'http://model.show.cydzy.com/8',
					 }, 22:{
						 title:'设计师官网模板',
						 imgurl:require('../assets/images/webpage/modelimgs/9.jpg'),
						 dourl:'http://model.show.cydzy.com/9',
					 }, 23:{
						 title:'纺织辅料企业官网',
						 imgurl:require('../assets/images/webpage/modelimgs/23.jpg'),
						 dourl:'http://model.show.cydzy.com/23',
					 },
				 }
				 
			 }
		}
	}
</script>
<style>
	.modelscontent{background: #E9EBEC;padding-top: 15px;}
	.modelsspecial{width: 80%;margin: 0 auto;min-height:248px;}
	.modelstopimg img{width:100%;}
	.modelsmargin-first{}
	.modelsmargin-all{margin-left: 2%;}
	.modelsconser{width: 23%;background: #ffffff;border-radius: 8px;text-align: center;float: left;}
	.modelsconser img{width: 100%;border-radius: 8px;}
	.modelsconser a{text-decoration:none}
	.modelsconser p:hover{color: cornflowerblue;}
	.modelsconser-title{font-size: 22px;font-weight: 600;}
	.el-footer{float: none;clear: both;}
	.modelsconser-tcon{font-size: 16px;}
</style>